import { Star } from 'lucide-react';
import React, { FC } from 'react';

import { Flex } from '../Flex';

interface StarsProps {
  rating: number;
}

export const Stars: FC<StarsProps> = ({ rating }) => (
  <Flex gap="5px" itemAlign="flex-start" justifyContent="flex-start">
    {[...Array(rating)].map((_, index) => (
      <Star key={index as number} size={20} color="gold" className="mr-1" />
    ))}
  </Flex>
);
